import Layout from '@/layout'

const DestinationBusinessRouter = {
  path: '/DestinationBusiness',
  component: Layout,
  redirect: 'noredirect',
  name: 'DestinationBusiness',
  meta: {
    title: '目的港业务',
    icon: 'daohang-ziliaoguanli',
    roles: []
  },
  children: [
    {
      path: 'EndCommerce',
      component: () => import('@/views/cargo/v0/DestinationBusiness/endCommerce'),
      name: 'EndCommerce',
      meta: { title: '尾程商务' },
      roles: ['module_EndCommerce']
    },
    {
      path: 'OverseaTracking',
      component: () => import('@/views/cargo/v0/DestinationBusiness/overseaTracking'),
      name: 'OverseaTracking',
      meta: { title: '海外跟单' },
      roles: ['module_OverseaTracking']
    }
  ]
}

export default DestinationBusinessRouter
